import { Box, Divider, Stack } from "@mui/material";
import InfoCard from "@/components/common/infoCard/infoCard";
import SectionHeader from "@/components/common/sectionHeader/sectionHeader";
import CareFormsSection from "@/components/serviceFlow/client/careFormsSection";
import ConsentFormTile from "@/components/serviceFlow/forms/consentForms/consentFormTile";
import ClientFormSubmissionVersions from "@/components/serviceFlow/forms/intakeForms/clientFormSubmissionVersions";

function FormSection({ forms, baseUrl }) {
  const { consentForms, intakeForms, precare, postcare } = forms;

  return (
    <Box>
      {intakeForms?.length > 0 && (
        <InfoCard sx={{ mb: 1.5 }}>
          <SectionHeader title="In–take forms" />
          <Stack
            divider={<Divider variant="fullWidth" sx={{ mb: 2, mt: 1 }} />}
            sx={{
              pt: 1,
            }}
          >
            {intakeForms?.map((formSubmission) => (
              <ClientFormSubmissionVersions
                key={formSubmission.id}
                formSubmission={formSubmission}
                baseUrl={baseUrl}
              />
            ))}
          </Stack>
        </InfoCard>
      )}
      {consentForms?.length > 0 && (
        <InfoCard sx={{ pb: "0 !important" }}>
          <SectionHeader title="Consent forms" />
          <Stack
            divider={<Divider variant="fullWidth" sx={{ mb: 2, mt: 1 }} />}
          >
            {consentForms.map((form) => (
              <ConsentFormTile
                withButton
                key={form.id}
                form={form}
                url={`${baseUrl}/consent-form/${form.id}`}
              />
            ))}
          </Stack>
        </InfoCard>
      )}
      <CareFormsSection title="Pre–care instructions" forms={precare} />
      <CareFormsSection title="Post–care instructions" forms={postcare} />
    </Box>
  );
}

export default FormSection;
